import React, { useState} from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from "@material-ui/core";
import { toast } from "react-toastify";
import { resetpassword } from "../../actions/users";
import InputField from "../../lib/ui/inputs/Input";
import CloseIcon from "@material-ui/icons/Close";
import Loader from "../../lib/ui/loader/Loader";

const ResetPwdPopup = ({ open, onClose, userData }) => {
    const [values, setValues] = useState({
        newPassword: "",
        confirmPassword: "",
        showNewPassword: false,
        showConfirmPassword: false,
    });
    const [errors, setErrors] = useState({
        newPassword: "",
        confirmPassword: "",
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        setValues({ ...values, newPassword: event.target.value });
        setErrors({ ...errors, newPassword: "" });
    };

    const handleconfirmChange = (event) => {
        setValues({ ...values, confirmPassword: event.target.value });
        setErrors({ ...errors, confirmPassword: "" });
    };

    const handleResetPassword = async () => {
        let validationErrors = {};
    
        if (values.newPassword.length < 8) {
            validationErrors.newPassword = "Password must be at least 8 characters long.";
        }
        else if (!/[A-Z]/.test(values.newPassword)) {
            validationErrors.newPassword = "Password must include at least one uppercase letter.";
        }
        else if (!/\d/.test(values.newPassword)) {
            validationErrors.newPassword = "Password must include at least one number.";
        }
        else if (!/[@$!%*?&]/.test(values.newPassword)) {
            validationErrors.newPassword = "Password must include at least one special character.";
        }
    
        if (values.newPassword !== values.confirmPassword) {
            validationErrors.confirmPassword = "Passwords do not match!";
        }
    
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
    
        const body = {
            userId: userData.userId,
            consultRole: userData.consultRole,
            newPwd: values.newPassword,
        };
    
        setLoading(true);
        try {
            await resetpassword(body);
            toast.success("Password reset successfully!");
            onClose();
        } catch (error) {
            toast.error(error?.response?.data?.error || "Password reset failed");
        } finally {
            setLoading(false);
        }
    };
    

    console.log('------------------', values?.newPassword);

    
    

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            PaperProps={{
                style: {
                    padding: "0px",
                },
            }}
        >
            <DialogTitle>Reset password for {userData.email}</DialogTitle>
            <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: "gray",
                    }}
                >
                    <CloseIcon />
                </IconButton>
            {loading && <Loader />}
            <DialogContent>
                <form id="newPasswordForm">
                    <div style={{paddingBottom:'10px'}}>
                        <InputField
                            placeholder='New Password'
                            type="password"
                            maxLength="30"
                            onChange={handleChange}
                            value={values.newPassword}
                            showPwd={true}
                        />
                         {errors.newPassword && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                                {errors.newPassword}
                            </span>
                        )}
                    </div>
                    <div>
                        <InputField
                            placeholder='Confirm Password'
                            type="password"
                            maxLength="30"
                            onChange={handleconfirmChange}
                            value={values.confirmPassword}
                            showPwd={true}
                        />
                        {errors.confirmPassword && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                                {errors.confirmPassword}
                            </span>
                        )}
                    </div>
                   
                </form>
            </DialogContent>
            <DialogActions style={{ padding: "12px 24px" }}>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    style={{ textTransform: "capitalize" }}
                    onClick={handleResetPassword}
                >
                    Reset
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ResetPwdPopup;
